(function ($) {
  "use strict";
  
      
      var $window_2 = $(window);
      $window_2.on('scroll', function () {
        var scroll = $window_2.scrollTop();
        if (scroll < 500) {
          $(".product-addtocart-sticky").removeClass("is-sticky-2");
        } else {
          $(".product-addtocart-sticky").addClass("is-sticky-2");
        }
      });
  
  
   $(function() {
    	$('.features-curosel2 > div').matchHeight(
        	
          
        );
	});
  
  	$(function() {
    	$('.right-products .tab-pane > div').matchHeight(
        	
          
        );
	});
  
  /* preloader */
  $(window).on('load', function() {
    $('#jhilmil-loader').fadeOut('slow');;
  }); 
  
  jQuery(document).ready(function(){

    $('.tas').parent('div').addClass('mega-menu-new'); 


    /*----- Mobile Menu -----*/
    $('.mobile-menu nav').meanmenu({
      meanScreenWidth: "990",
      meanMenuContainer: ".mobile-menu",
    });

    /*----- main slider -----*/	
    $('#mainSlider').nivoSlider({
      animSpeed: 1000,
      pauseTime: 5000,
      startSlide: 0,
      directionNav: true,
      controlNavThumbs: true,
      pauseOnHover: true,
      manualAdvance: false,
      prevText: '<i class="fa fa-angle-left nivo-prev-icon"></i>',
      nextText: '<i class="fa fa-angle-right nivo-next-icon"></i>'
    });
    

    
   
    /*----- Propular Product Slider -----*/
    $(".propular-slider").owlCarousel({
      autoplay: false,
      loop: true,
      nav: true,
      margin: 30,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      dots: false,
      responsive:{
        992:{items:4,},
        768:{items:3,},
        480:{items:2,},
        0:{items:1,},
      }
    });

    $('.height-product').matchHeight();  

    /*----- Feature Product Slider -----*/
    $(".feature-slider").owlCarousel({
      autoplay: false,
      loop: true,
      nav: true,
      margin: 30,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      dots: false,
      responsive:{
        992:{items:3,},
        768:{items:2,},
        0:{items:1,},
      }
    });

    /*----- Testimonial Slider -----*/
    $(".testimonial-slider").owlCarousel({
      items: 1,
      autoplay: false,
      loop: true,
      nav: false,
      dots: true,
    });

    /*----- Propular Sidebar Slider -----*/
    $(".propular-sidebar-slider").owlCarousel({
      autoplay: false,
      loop: true,
      nav: true,
      margin: 30,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      dots: false,
      responsive:{
        992:{items:1,},
        480:{items:2,},
        0:{items:1,},
      }
    });

    /*----- Feature Sidebar Slider -----*/
    $(".feature-sidebar-slider").owlCarousel({
      autoplay: false,
      loop: true,
      nav: true,
      margin: 30,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      dots: false,
      responsive:{
        992:{items:1,},
        768:{items:2,},
        0:{items:1,},
      }
    });

    /*----- Blog Slider -----*/
    $(".blog-slider").owlCarousel({
      autoplay: false,
      loop: false,
      nav: true,
      margin: 30,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      dots: false,
      responsive:{
        0:{items:1,},
        750:{items:2,},
        992:{items:3,},
      }
    });
    $("#tabs-details").owlCarousel({
      autoPlay: false, 
      slideSpeed:1000,
      pagination:false,
      navigation:true,	  
      items : 4,
      /* transitionStyle : "fade", */    /* [This code for animation ] */
      navigationText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [991,3],
      itemsTablet: [767,3],
      itemsMobile : [479,3],
    });
    /*----- Blog Slider -----*/
    $(".blog-slider-2").owlCarousel({
      autoplay: false,
      loop: true,
      nav: true,
      margin: 30,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      dots: false,
      responsive:{
        0:{items:1,},
        750:{items:2,},
        992:{items:2,},
      }
    });

    $("#related-products").owlCarousel({
      autoplay: false,
      loop: true,
      nav: true,
      margin: 30,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      dots: false,
      responsive:{
        0:{items:1,},
        750:{items:2,},
        992:{items:4,},
      }
    });
    
    
    /*----- Blog Match Height -----*/
    $('.single-blog').matchHeight();

    /*----- Brand Slider -----*/
    $(".brand-slider").owlCarousel({
      autoplay: false,
      loop: true,
      nav: true,
      margin: 30,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      dots: false,
      responsive:{
        0:{items:2,},
        750:{items:4,},
        950:{items:5,},
        1170:{items:6,},
      }
    });
    /*----- Scroll Up -----*/
    $.scrollUp({
      scrollText: '<i class="fa fa-chevron-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });


    /*----- Check Out Accordion -----*/
    $(".panel-heading a").on("click", function(){
      $(".panel-heading a").removeClass("active");
      $(this).addClass("active");
    });

    /*----- Cart Plus Minus Button -----*/	
    $(".pro-quantity").prepend('<span class="dec qtybutton">-</span>');
    $(".pro-quantity").append('<span class="inc qtybutton">+</span>');
    $(".qtybutton").on("click", function() {
      var $button = $(this);
      var oldValue = $button.parent().find("input").val();
      if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
      }
      $button.parent().find("input").val(newVal);
    });	


    /*----------------------------
         Elevate Zoom active
    ------------------------------ */
    $(".zoom1").elevateZoom({
      gallery:'tabs-details',
      cursor: 'pointer',
      galleryActiveClass: "active",
      imageCrossfade: true,
      zoomWindowFadeIn: 300,
      zoomWindowFadeOut: 300,
      lensFadeIn: 300,
      lensFadeOut: 300,
      easing : true
    });



  });
})(jQuery); 